var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import i18next from "i18next";
import { BookModel } from "../BookModel";
import { dateFormat } from "../../../helpers/date";
import { AppointmentModelCollection } from "./AppointmentModelCollection";
var AppointmentModel = /** @class */ (function (_super) {
    __extends(AppointmentModel, _super);
    function AppointmentModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFormatted = function (prop, format) {
            if (format === void 0) { format = i18next.t("date.date_format"); }
            var value = _this.get(prop);
            return value && dateFormat(value, format);
        };
        return _this;
    }
    AppointmentModel.getCollectionClass = function () {
        return AppointmentModelCollection;
    };
    Object.defineProperty(AppointmentModel.prototype, "startTime", {
        get: function () {
            return this.getFormatted("from", i18next.t("date.time_format"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppointmentModel.prototype, "endTime", {
        get: function () {
            return this.getFormatted("to", i18next.t("date.time_format"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppointmentModel.prototype, "startDate", {
        get: function () {
            return this.getFormatted("from");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppointmentModel.prototype, "endDate", {
        get: function () {
            return this.getFormatted("to");
        },
        enumerable: false,
        configurable: true
    });
    AppointmentModel.prototype.getFormattedValue = function (placement, prop) {
        return i18next.t(placement + "." + prop, {
            startTime: this.startTime,
            endTime: this.endTime,
            startDate: this.startDate,
            endDate: this.endDate,
        });
    };
    AppointmentModel.prototype.getFromToAuto = function (placement) {
        var toDateSeparator = i18next.t("date.to_date_separator");
        var _a = this, startDate = _a.startDate, endDate = _a.endDate, startTime = _a.startTime, endTime = _a.endTime;
        var isSameDay = startDate === endDate;
        var isSameTime = startTime === endTime;
        var prependToDateSeparator = function (str) {
            if (!(str === null || str === void 0 ? void 0 : str.trim()))
                return "";
            return toDateSeparator + " " + str;
        };
        return i18next.t(placement + ".from_to_auto", {
            fromDate: startDate,
            fromTime: this.startTime,
            toTime: !isSameDay ? endTime : (isSameTime ? "" : prependToDateSeparator(endTime)),
            toDate: isSameDay ? "" : prependToDateSeparator(endDate),
        });
    };
    AppointmentModel.prototype.getTimespans = function () {
        return this.belongsToMany("course_timespans", "computedAppointments");
    };
    AppointmentModel.dates = ["from", "to"];
    return AppointmentModel;
}(BookModel));
export { AppointmentModel };
